import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class LocaleService {

	constructor(private _cS: CookieService) {
		if (this._cS.check('Len')) {
			this.locale = this._cS.get('Len');
		} else {
			this.locale = 'eng';
		}
	}

	private _locale: string;

	set locale(value: string) {
		this._locale = value;
	}
	get locale(): string {
		return this._locale || 'eng';
	}
}